import React from "react";
import { Card, ProgressBar, Row, Col, Badge } from "react-bootstrap";
import { useAuth } from "contexts/AuthContext";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ProfileCompletionStatus = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  // Define profile fields and their completion status
  const profileFields = [
    { key: "firstName", label: "First Name", required: true },
    { key: "lastName", label: "Last Name", required: true },
    { key: "email", label: "Email", required: true },
    { key: "phone", label: "Phone", required: true },
    { key: "profilePhoto", label: "Profile Photo", required: true },
    { key: "securityPhoto", label: "Security Photo", required: true },
    // { key: "coverImage", label: "Cover Image", required: true },
    { key: "middleName", label: "Middle Name", required: false },
  ];

  // Calculate completion percentage
  const completedFields = profileFields.filter((field) => {
    const value = user[field.key];
    return value && value.toString().trim() !== "";
  });

  const requiredFields = profileFields.filter((field) => field.required);
  const completedRequiredFields = requiredFields.filter((field) => {
    const value = user[field.key];
    return value && value.toString().trim() !== "";
  });

  const completionPercentage = Math.round(
    (completedRequiredFields.length / requiredFields.length) * 100
  );
  const isComplete = completionPercentage === 100;

  return (
    <Card className="mb-4 p-4 custom-shadow">
      <h5 className="mb-0 text-sm fw-bold text-center">Profile Completion</h5>
      <Card.Body className="p-0 mt-3">
        <div className="w-100 d-flex align-items-center justify-content-center">
          <div style={{ width: 120, height: 120 }}>
            <CircularProgressbar
              value={completionPercentage}
              text={`${completionPercentage}%`}
              strokeWidth={10}
              styles={buildStyles({
                pathColor: "#00d27a", // Bootstrap success green
                textColor: "#00d27a",
                trailColor: "#e9ecef",
                textSize: "20px",
                strokeLinecap: "round",
              })}
            />
          </div>
        </div>

        <div className="mb-3 mt-3">
          <h6 className="text-muted mb-2">Required fields:</h6>
          <div className="d-flex flex-wrap gap-2">
            {requiredFields.map((field) => {
              const isCompleted =
                user[field.key] && user[field.key].toString().trim() !== "";
              return (
                <div
                  key={field.key}
                  className={`d-flex align-items-center justify-content-center px-2 py-1 rounded-pill small-pill ${
                    isCompleted ? "pill-success" : "pill-muted"
                  }`}
                  style={{ fontSize: "0.75rem" }}
                >
                  <FontAwesomeIcon
                    icon={isCompleted ? "check-circle" : "circle"}
                    className="me-1"
                  />
                  {field.label}
                </div>
              );
            })}
          </div>
        </div>

        <div>
          <h6 className="text-muted mb-2">Optional fields:</h6>
          <div className="row g-2">
            {profileFields
              .filter((field) => !field.required)
              .map((field) => {
                const isCompleted =
                  user[field.key] && user[field.key].toString().trim() !== "";
                return (
                  <div key={field.key} className="col-6">
                    <div
                      className={`d-flex align-items-center px-2 py-1 rounded-pill small-pill ${
                        isCompleted ? "pill-success" : "pill-muted"
                      }`}
                      style={{ fontSize: "0.75rem" }}
                    >
                      <FontAwesomeIcon
                        icon={isCompleted ? "check-circle" : "circle"}
                        className="me-1"
                      />
                      {field.label}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        {!isComplete && (
          <div className="mt-3 p-3 bg-light rounded">
            <small className="text-muted">
              <FontAwesomeIcon icon="info-circle" className="me-1" />
              Complete all required fields to reach 100% profile completion.
            </small>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default ProfileCompletionStatus;
